// UTM parameter utility for tracking
export const getCheckoutUrl = () => {
  const baseUrl = 'https://cart.payneseducation.com/pecs/checkout';
  
  // Get current URL parameters
  const currentParams = new URLSearchParams(window.location.search);
  
  // UTM parameters to track
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'fbclid', 'gclid', 'msclkid'];
  
  // Build checkout URL with UTM params
  const checkoutParams = new URLSearchParams();
  
  utmParams.forEach(param => {
    const value = currentParams.get(param);
    if (value) {
      checkoutParams.set(param, value);
    }
  });
  
  // Return URL with params if any exist
  const paramString = checkoutParams.toString();
  return paramString ? `${baseUrl}?${paramString}` : baseUrl;
};

// Hook for reactive UTM URL
export const useCheckoutUrl = () => {
  return getCheckoutUrl();
};
